import { fabricConstants } from "../../constants";
import { fabricService } from "../../services";
import { alertActions } from "../alert.actions";

export const fabricActions = {
  getSingleParameter,
  getAllParameters,
  addParameter,
  updateParameter,
  deleteParameter,
  clear,
};

// get single parameter
function getSingleParameter() {}

// get all parameter
function getAllParameters() {
  return (dispatch) => {
    dispatch(request());

    fabricService.getAllParameters().then(
      (items) => dispatch(success(items)),
      (error) => dispatch(failure(error))
    );
  };

  function request(params) {
    return { type: fabricConstants.GET_ALL_REQUEST, params };
  }
  function success(items) {
    return { type: fabricConstants.GET_ALL_SUCCESS, items };
  }
  function failure(error) {
    return { type: fabricConstants.GET_ALL_FAILURE, error };
  }
}

// add parameter
function addParameter(name, chinese_name, technical_name, status,color_ids) {
  return (dispatch) => {
    dispatch(request(name, chinese_name, technical_name, status,color_ids));

    fabricService.addParameter(name, chinese_name, technical_name, status,color_ids).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: fabricConstants.ADD_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: fabricConstants.ADD_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: fabricConstants.ADD_FAILURE, error };
  }
}

// update parameter
function updateParameter(id, name, chinese_name, technical_name, status,color_ids) {
  return (dispatch) => {
    dispatch(request(id, name, chinese_name, technical_name, status,color_ids));

    fabricService
      .updateParameter(id, name, chinese_name, technical_name, status,color_ids)
      .then(
        (parameter) => {
          dispatch(success(parameter));
          dispatch(alertActions.success(parameter));
        },
        (error) => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      );
  };

  function request(parameter) {
    return { type: fabricConstants.UPDATE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: fabricConstants.UPDATE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: fabricConstants.UPDATE_FAILURE, error };
  }
}

// delete parameter
function deleteParameter(id) {
  return (dispatch) => {
    dispatch(request(id));

    fabricService.deleteParameter(id).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: fabricConstants.DELETE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: fabricConstants.DELETE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: fabricConstants.DELETE_FAILURE, error };
  }
}

// clear parameter
function clear() {
  return { type: fabricConstants.CLEAR };
}
